import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermsPageComponent } from './terms-page/terms-page.component';
import { PartialModule } from '../partial/partial.module';

@NgModule({
  declarations: [
    TermsPageComponent
  ],
  imports: [
    CommonModule,
    PartialModule
  ],
  exports: [
    TermsPageComponent
  ]
})
export class TermsModule { }
